import {fontPrimary} from '@commercial-helios/ui'

const fontLoader = () => {
    if ('fonts' in document) {
        document.fonts.load(`1em ${fontPrimary}`).then((_) => {
            document.documentElement.classList.add('wf-active')
        })
    }
}

export default fontLoader
